<template>
  <TransactionListTemplate
    :screen-config="setScreenConfig"
    :row-click="rowClickCallBack"
    persistence-key="Work-Order-draft-list"
    :setLoading="setLoading"
    :ref="screenRef"
    :gcPopupConfig="gcPopupConfig"
  >
    <template #popup>
      <GcPopUpWorkOrder
        :popupConfig="popup"
        :on-hide="onPopupHide"
        :wrapper-attr="{
          class: 'css-v2 gc-popup gc-popup-form gc-popup-work-order',
        }"
        :data-model="dataModel"
        :show-loading="ShowLoading"
        :width="1024"
        :height="370"
        :save-call-back="onWorkOrderSave"
        :displayServerError="displayServerErrorOnTemplate"
        v-if="popup.isPopupShow"
      />
    </template>
  </TransactionListTemplate>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";

import TransactionListTemplate from "@/templates/transaction-list";
import { FeatureStorage } from "@/_services/storage";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import { WorkOrderService } from "@/_services/api/production/work-order.service";
import {
  GetIndexByTabName,
  WorkOrderTabs,
} from "../../../_models/tabdata/production/work-order-tabs";
import { getFilteredValueByKey } from "../../../_helpers/templates/transaction-list";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      transactionListKey: 0,
      model: {
        BomCode: null,
        Branch: null,
        QuoteCode: 0,
        Code: 0,
        Comments: "",
        CompanyCode: "",
        Division: null,
        Product: null,
        Quantity: 0,
        Required: new Date(),
        Scheduled: new Date(),
        DateIn: new Date(),
      },
      initialModel: null, // To store the initial state
      popup: {
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 370,
        isPopupShow: false,
        hideOnOutsideClick: false,
        // toolbarMenuItems: [
        //   {
        //     menuText: "Copy",
        //     visible: false, // pending discussions #54331
        //   },
        //   { menuText: "Cancel", onClick: this.onCancelWorkOrderHandler },
        //   { menuText: "Reopen", onClick: this.onReopenWorkOrderHandler },
        //   { menuText: "Complete", onClick: this.onCompleteWorkOrderHandler },
        // ],
        formMode: "create",
        isEditable: false,
      },
      setLoading: false,
      dataModel: undefined,
      visibleRowCount: 0,
      substituteModel: {
        MaterialCode: undefined,
        NewMaterialCode: undefined,
      },
      NewMaterialUpdated: false,
      gcPopupVisible: false,
      screenRef: "work-order-list",
      materialFilterField: "MaterialDataList/MaterialCode",
    };
  },
  computed: {
    setScreenConfig() {
      return {
        title: "Work Orders",
        ScreenName: "Work Orders",
        exportFileName: "Work Order List - Draft",
        selectedIndex: GetIndexByTabName("Draft"),
        tabs: WorkOrderTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "WorkOrderList",
              filter: [
                ["FriendlyStatus", "=", "Draft"],
                "and",
                [["WOType", "=", "Production"], "or", ["WOType", "=", null]],
              ],
              serverPaging: true,
              allowGrouping: false,
              select: [
                "BomCode",
                "BomDescription",
                "ChangedBy",
                "Code",
                "CreatedBy",
                "DateChanged",
                "DateCreated",
                "FriendlyStatus",
                "ItemQty",
                "ProductCode",
                "ProductDescription",
                "ProductDescription1",
                "ProductDescription2",
                "SalesOrderList",
                "ScheduledDate",
                "ShipDate",
                "Status",
                "BranchCode",
                "ProductCategory1Code",
                "ProductCategory2Code",
                "ProductCategory3Code",
                "ProductCategory4Code",
                "ProductTypeCode",
                "Attribute01",
                "Attribute02",
                "Attribute03",
                "Attribute04",
                "Attribute05",
                "Attribute06",
                "Attribute07",
                "Attribute08",
                "Attribute09",
                "Attribute10",
                "Attribute11",
                "Attribute12",
                "Attribute13",
                "Attribute14",
                "Attribute15",
                "Attribute16",
                "Attribute17",
                "Attribute18",
                "Attribute19",
                "Attribute20",
                "WOType",
                "MaterialList",
              ],
              keyType: {
                ...this.getAttributeKeyTypes(),
              },
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Work Order",
                message: "Get Started, Add a Work Order",
              },
            },
            options: {
              selectionMode: "multiple",
              allowSelectAll: false,
              onContentReadyCallBack: this.onContentReadyCallBack,
            },
          },
          toolbar: {
            screenName: "Work Orders",
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            multiplePdf: true,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                clickAction: this.onNewWorkOrderHandler,
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission("WorkOrder", "create"),
              },
            ],
            ellipsis: {
              menuItems: [
                {
                  menuText: "Material Substitution",
                },
              ],
              clickAction: (e) => {
                this.onMaterialSubstitutionClicked(e);
              },
              onButtonClick: (e) => {
                if (e) {
                  const items = e.component.option("items");
                  const index = items.findIndex(
                    (i) => i.menuText === "Material Substitution",
                  );
                  if (index !== -1) {
                    e.component.option(
                      `items[${index}].disabled`,
                      !this.isSubstitutionEnabled,
                    );
                  }
                }
              },
            },
          },
          columns: [
            {
              screenField: "Code",
              filterLabel: "Work Order",
              label: "Work Order",
              gridDataField: "Code",
              sortOrder: "desc",
              filterIndex: 1,
              type: "Integer",
              sortIndex: 0,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              minWidth: ColumnWidth.PurchaseOrderCode.minWidth,
              width: ColumnWidth.PurchaseOrderCode.width,
              // forceWidth: true,
            },
            {
              screenField: "SalesOrder",
              gridDataField: "SalesOrderList",
              dataField: "SalesOrderList",
              filterDataField: "SalesOrderList",
              type: "Text",
              filterIndex: 1,
              showInColumnChooser: false,
              visible: false,
            },
            {
              screenField: "Product",
              label: "Product",
              filterIndex: 2,
              width: "auto",
              allowHiding: false,
              filterOverWrites: {
                select: [
                  "Code",
                  "Description1",
                  "Inactive",
                  "Status",
                  "Source",
                ],
                filter: [
                  ["Inactive", "=", "N"],
                  "and",
                  ["Status", "=", "A"],
                  "and",
                  ["Source", "=", "M"],
                ],
              },
            },
            {
              screenField: "Product",
              filterLabel: "Material",
              filterIndex: 3,
              filterDataRelationship: "Child",
              filterOperator: "=",
              filterDataField: this.materialFilterField,
              gridDataField: "MaterialList",
              showInColumnChooser: false,
              visible: false,
            },
            {
              screenField: "BOM",
              label: "BOM",
              filterIndex: 3,
              allowHiding: false,
            },
            {
              screenField: "Branch",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 3,
              allowExporting: false,
              filterOverWrites: {
                select: ["Code", "Description", "Inactive", "ManufactureFlag"],
                filter: [
                  ["Inactive", "=", "N"],
                  "and",
                  ["ManufactureFlag", "=", "Y"],
                ],
              },
            },
            {
              screenField: "ItemQty",
              label: "Planned Qty",
              minWidth: ColumnWidth.Quantity.minWidth,
              width: ColumnWidth.Quantity.width,
            },
            {
              screenField: "DateIn",
              dataField: "ScheduledDate",
              filterDataField: "ScheduledDate",
              filterLabel: "Scheduled Date",
              label: "Scheduled",
              filterIndex: 4,
              minWidth: ColumnWidth.Date.minWidth,
              width: ColumnWidth.Date.width,
            },
            {
              screenField: "ShipDate",
              label: "Required",
              filterLabel: "Required Date",
              filterDataField: "ShipDate",
              filterIndex: 5,
              minWidth: ColumnWidth.Date.minWidth,
              width: ColumnWidth.Date.width,
            },
            {
              screenField: "Status",
              gridDataField: "FriendlyStatus",
              dataField: "FriendlyStatus",
              filterDataField: "FriendlyStatus",
              label: "",
              // filterIndex: 6,
              cellTemplate: "Status",
              fixed: true,
              dataSourceConfig: {
                data: [
                  { key: "Active", value: "Active" },
                  { key: "Cancelled", value: "Cancelled" },
                  { key: "Completed", value: "Completed" },
                  { key: "Draft", value: "Draft" },
                  { key: "In Production", value: "In Production" },
                ],
              },
            },
            {
              screenField: "DistinctProductionUM",
              filterIndex: 7,
              showInColumnChooser: false,
              visible: false,
            },
            {
              screenField: "DistinctProductionUMConversion",
              filterIndex: 8,
              showInColumnChooser: false,
              visible: false,
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  return [
                    {
                      menuText: "Copy",
                      data: data,
                      clickAction: this.onCopyWorkOrderHandler,
                      visible: true, // pending discussions #54331
                    },
                    {
                      menuText: "Cancel",
                      data: data,
                      clickAction: this.onCancelWorkOrderHandler,
                      disabled: data.data.FriendlyStatus !== "Active",
                    },
                    {
                      menuText: "Reopen",
                      data: data,
                      clickAction: this.onReopenWorkOrderHandler,
                      disabled:
                        data.data.FriendlyStatus !== "Completed" &&
                        data.data.FriendlyStatus !== "Cancelled",
                    },
                    {
                      menuText: "Complete",
                      data: data,
                      clickAction: this.onCompleteWorkOrderHandler,
                      disabled: data.data.FriendlyStatus !== "In Production",
                    },
                  ];
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: () => {
                return !FeatureStorage.checkPermission("WorkOrder", "create");
              },
            },
            {
              screenField: "ProductCategory1",
              label: "Category 1",
              filterLabel: "Category 1",
              filterIndex: 9,
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "ProductCategory2",
              label: "Category 2",
              filterLabel: "Category 2",
              filterIndex: 10,
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "ProductCategory3",
              label: "Category 3",
              filterLabel: "Category 3",
              filterIndex: 11,
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "ProductCategory4",
              label: "Category 4",
              filterLabel: "Category 4",
              filterIndex: 12,
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "ProductType",
              label: "Type",
              filterLabel: "Type",
              filterIndex: 13,
              visible: false,
              showInColumnChooser: false,
            },
          ].concat(this.getAttributeColumns(11, false, false)),
        },
      };
    },
    isSubstitutionEnabled() {
      const isSelectedWorkOrdersValid = this.getSelectedRows.every(
        (row) =>
          row.FriendlyStatus === "Draft" ||
          row.FriendlyStatus === "Awaiting Production" ||
          row.FriendlyStatus === "Planning",
      );

      if (!isSelectedWorkOrdersValid) {
        return false;
      }

      return (
        FeatureStorage.checkPermission("BillOfMaterial", "create") &&
        this.visibleRowCount > 0 &&
        getFilteredValueByKey(
          this.$refs,
          this.screenRef,
          this.materialFilterField,
        ).length === 1
      );
    },
    getSelectedRows() {
      return this.$refs[this.screenRef].$refs[
        "transactionListGrid"
      ].selectedRowData();
    },
    gcPopupConfig() {
      return {
        title: "Material Substitution",
        dataModel: this.substituteModel,
        callBack: this.gcPopupCallBack,
        gcPopupVisible: this.gcPopupVisible,
        height: 100,
        formOptions: {
          gcLabelLocation: "left",
        },
        items: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                screenField: "Product",
                dataField: "MaterialCode",
                label: {
                  text: "Original Material",
                },
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description1;
                  else return "";
                },
              },
              {
                screenField: "Product",
                dataField: "NewMaterialCode",
                label: {
                  text: "Replacement Material",
                },
                editorOptions: {
                  allowUpdate: true,
                  showClearButton: true,
                  onValueChanged: (e) => {
                    this.onChangeNewMaterialCode(e);
                  },
                },
                filter: [
                  ["Code", "<>", `${this.substituteModel.MaterialCode}`],
                ],
                required: true,
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description1;
                  else return "";
                },
                searchExpr: ["Code", "Description1"],
              },
            ],
          },
        ],
        save: {
          text: "Update",
          clickCallback: (e) => {
            this.onGcPopUpUpdate(e);
          },
          // disabled: !this.NewMaterialUpdated,
        },
        back: {
          text: "Cancel",
          clickCallback: () => {
            this.gcPopupCallBack();
          },
        },
      };
    },
  },
  created() {},
  methods: {
    /**
     * Show Loading
     * @param value
     * @constructor
     */
    ShowLoading(value) {
      this.setLoading = value;
    },
    /**
     * Hide A popup
     */
    onPopupHide() {
      this.popup.isPopupShow = false;
    },

    onWorkOrderSave(close = true) {
      if (close) {
        this.onPopupHide();
        this.showLoading(true);
      }

      if (this.popup.displayForScheduleEditing) {
        WorkOrderService.getByCode(this.popup.workOrderCode).then(
          (response) => {
            const workOrderDetail = response.data.value[0];
            this.dataModel = workOrderDetail;
            this.dataModel.FriendlyStatus = workOrderDetail.FriendlyStatus;

            this.popup.title = `Work Order #${workOrderDetail.Code}`;
            this.popup.workOrderCode = workOrderDetail.Code;
            this.popup.secondaryTitle =
              workOrderDetail.ProductCode +
              " - " +
              workOrderDetail.ProductDescription;
            this.popup.isEditable = true;
            this.popup.triggerEdit = FeatureStorage.checkPermission(
              "WorkOrder",
              "edit",
            );

            this.$nextTick(() => {
              this.showModalReview();
            });
          },
        );
      } else {
        this.$refs[this.screenRef].$refs["transactionListGrid"].gridRepaint();
      }
    },

    /**
     * On New Work Order Handler
     */
    async onNewWorkOrderHandler() {
      this.popup.title = "Create Work Order";

      this.popup.triggerEdit = false;
      this.popup.displayForScheduleEditing = false;
      this.popup.hideOnOutsideClick = false;
      this.popup.formMode = "create";

      this.$nextTick(() => {
        this.showPopupModal();
      });
    },

    /**
     * On Copy Work Order
     * @param data
     * @param grid
     */
    async onCopyWorkOrderHandler(data) {
      this.popup.title = "Create Work Order";

      this.popup.hideOnOutsideClick = false;
      this.popup.formMode = "create";

      const response = await WorkOrderService.getByCode(data.Code);
      const workOrderDetail = response.data.value[0];
      this.dataModel = workOrderDetail;
      // this.dataModel.FriendlyStatus = e.data.FriendlyStatus;

      // this.popup.title = `Work Order #${workOrderDetail.Code}`;
      this.popup.workOrderCode = workOrderDetail.Code;
      // this.popup.secondaryTitle =
      //   data.ProductCode + " - " + data.ProductDescription;
      this.popup.isEditable =
        (this.dataModel.FriendlyStatus === "Active" ||
          this.dataModel.FriendlyStatus === "In Production") &&
        FeatureStorage.checkPermission("WorkOrder", "edit");

      this.popup.formMode = "copy";

      this.showPopupModal();
    },

    /**
     * On Cancel Work Order
     * @param data
     * @param grid
     */
    async onCancelWorkOrderHandler(data, grid) {
      let confirmCancel = await this.$confirm(
        "Do you want to cancel this work order?",
        "Cancel Work Order",
      );

      if (confirmCancel) {
        this.onPopupHide();
        this.setLoading = true;
        await WorkOrderService.cancelWorkOrder({
          Code: data.Code.toString(),
          DateChanged: new Date().toISOString().replace("Z", ""),
        })
          .then((res) => {
            this.$notify(
              `Work Order #${data.Code} Successfully Cancelled`,
              "success",
            );
            this.setLoading = false;
            if (res) grid.refresh();
          })
          .catch((err) => {
            this.setLoading = false;
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Cancel Work Order Failed",
            });
          });
      }
    },
    /**
     * On Reopen Work Order Handler
     * @param data
     * @param grid
     */
    async onReopenWorkOrderHandler(data, grid) {
      let confirmReOrder = await this.$confirm(
        "Do you want to re-open this work order?",
        "Re-Open Work Order",
      );

      if (confirmReOrder) {
        this.onPopupHide();
        this.setLoading = true;
        await WorkOrderService.reopenWorkOrder({
          Code: data.Code.toString(),
          DateChanged: new Date().toISOString().replace("Z", ""),
        })
          .then((res) => {
            this.$notify(
              `Work Order #${data.Code} Successfully Re-Opened.`,
              "success",
            );
            this.setLoading = false;
            if (res) grid.refresh();
          })
          .catch((err) => {
            this.setLoading = false;
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Re-Open Work Order Failed",
            });
          });
      }
    },
    /**
     * On Complete Work Order Handler
     * @param data
     * @param grid
     */
    async onCompleteWorkOrderHandler(data, grid) {
      let confirmComplete = await this.$confirm(
        "Do you want to complete this work order?",
        "Complete Work Order",
      );

      if (confirmComplete) {
        this.onPopupHide();
        this.setLoading = true;
        await WorkOrderService.completeWorkOrder({
          Code: data.Code.toString(),
          DateChanged: new Date().toISOString().replace("Z", ""),
        })
          .then((res) => {
            this.$notify(
              `Work Order #${data.Code} Successfully Completed`,
              "success",
            );
            this.setLoading = false;
            if (res) grid.refresh();
          })
          .catch((err) => {
            this.setLoading = false;
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Complete Work Order Failed",
            });
          });
      }
    },

    displayServerErrorOnTemplate(err, msg) {
      this.$store.dispatch("ui/setServerError", {
        error: err,
        title: msg,
      });
    },
    /**
     * Show Popup Modal
     */
    showPopupModal() {
      this.popup.popupKey++;
      this.popup.isPopupShow = true;
    },

    /**
     * Show Modal Review
     */
    showModalReview() {
      this.popup.hideOnOutsideClick = true;
      this.popup.formMode = "review";
      this.showPopupModal();
    },
    /**
     * On Row Click CallBack
     * @param e
     */
    async rowClickCallBack(e) {
      if (
        e.rowType === "data" &&
        e.column.screenField !== "Status" &&
        e.column.screenField !== "GridRecordPDFView" &&
        e.column.screenField !== "GridRecordEllipsisMenu" &&
        e.column.screenField !== "GridRecordPrint" &&
        e.column.type !== "selection"
      ) {
        const response = await WorkOrderService.getByCode(e.data.Code);
        const workOrderDetail = response.data.value[0];
        this.dataModel = workOrderDetail;
        this.dataModel.FriendlyStatus = e.data.FriendlyStatus;

        this.popup.title = `Work Order #${workOrderDetail.Code}`;
        this.popup.workOrderCode = workOrderDetail.Code;
        this.popup.secondaryTitle =
          e.data.ProductCode + " - " + e.data.ProductDescription;
        this.popup.isEditable =
          (this.dataModel.FriendlyStatus === "Active" ||
            this.dataModel.FriendlyStatus === "In Production") &&
          FeatureStorage.checkPermission("WorkOrder", "edit");
        this.popup.triggerEdit = false;
        this.popup.displayForScheduleEditing = false;

        this.showModalReview();
      }
    },

    onContentReadyCallBack(e) {
      setTimeout(() => {
        const gridInstance = e.component;
        const visibleRows = gridInstance.getVisibleRows();
        this.visibleRowCount = visibleRows.length;
      }, 100);
    },

    onMaterialSubstitutionClicked(e) {
      if (!e) return;

      if (this.getSelectedRows.length === 0) {
        this.$alert(
          "Please select one or more work orders to perform material substitution.",
          "No Work Order Selected",
        );
        return;
      } else {
        this.substituteModel = {
          MaterialCode: undefined,
        };
        const material = getFilteredValueByKey(
          this.$refs,
          this.screenRef,
          this.materialFilterField,
        );
        this.substituteModel.MaterialCode = material.length
          ? material[0]
          : null;

        this.$nextTick(() => {
          this.gcPopupVisible = true;
        });
      }
    },
    onChangeNewMaterialCode(e) {
      this.substituteModel["NewMaterialCode"] = e.value;
    },

    gcPopupCallBack() {
      this.gcPopupVisible = false;
    },

    refreshList(refresh = false) {
      this.$refs[this.screenRef].$refs["transactionListGrid"].gridRefresh(
        refresh,
      );
    },

    async onGcPopUpUpdate() {
      let selectedRows =
        this.$refs[this.screenRef].$refs[
          "transactionListGrid"
        ].selectedRowData();

      if (selectedRows.length === 0) {
        await this.$alert(
          "Please select one or more BOM records to perform material substitution.",
          "No Records Selected",
        );

        return;
      }

      const payload = {
        SourceMaterialCode: this.substituteModel.MaterialCode,
        ReplacementMaterialCode: this.substituteModel.NewMaterialCode,
        WorkOrderCodes: selectedRows.map((row) => row.Code),
      };

      this.setLoading = true;
      try {
        const response = await WorkOrderService.updateMaterialSubstitute(
          payload,
        );

        if (response && response.data) {
          this.$notify(response.data.SuccessMessage, "success");
        }
        this.NewMaterialUpdated = false;
        this.setLoading = false;

        this.$nextTick(() => {
          this.refreshList(true);
          this.gcPopupCallBack();
        });
      } catch (error) {
        this.setLoading = false;
        this.displayServerErrorOnTemplate(
          error,
          "An error occurred while updating material substitution. Please try again.",
        );
      }
    },
  },
};
</script>

<style lang="scss"></style>
